/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Storage_Spaces_Near_LimitInputs */



/**
* | output |
* | --- |
* | "Spaces Near Limit" |
*
* @param {Dashboard_Storage_Spaces_Near_LimitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_storage_spaces_near_limit = /** @type {((inputs?: Dashboard_Storage_Spaces_Near_LimitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Storage_Spaces_Near_LimitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bereiche nahe Limit")
	return /** @type {LocalizedString} */ ("Spaces Near Limit")
});